import React from 'react'
import './report-of-invoices-generated.css'

const ReportOfInvoicesGenerated = (props) => {
    
    const tryToClose = (id) => {
        if(id === 'report-of-invoices-generated__wrapper'){
            props.setInvoicesHaveBeenGenerated()
        }
    }

    return (
        <div className='report-of-invoices-generated__wrapper' id='report-of-invoices-generated__wrapper' onClick={(e) => tryToClose(e.target.id)}>
            <div className='report-of-invoices-generated__box'>
                <div className='report-of-invoices-generated__x-wrapper'>
                    <div className='report-of-invoices-generated__x' onClick={(e) => tryToClose('report-of-invoices-generated__wrapper')}>X</div>
                </div>
                <h1>Invoices Generated</h1>
                {props.listOfInvoicesGeneratedSuccessfully.map((fam) =>
                    <div className='report-of-invoices__each-name' style={fam.generated ? {color: 'green'} : {color: 'red'}}>{fam.name} <p className='report-of-invoices__status'>{fam.generated ? 'Generated' : 'FAILED'}</p></div>
                )}
            </div>
        </div>
    )
}
export default ReportOfInvoicesGenerated